import router from './router'
import * as userContext from '@/utils/userContext'

const whiteList = ['/login', '/register','/forgotPassword']// 不重定向白名单

router.beforeEach((to, from, next) => 
{
  if(to.path==="/")
  {
    next('/weeklyReport/post') 
  }

  // 判断是否有token
  if (userContext.getToken()) 
  { 
    if (to.path === '/login') 
    {
      next()
    }
    else
    {
      next()
    }
  } 
  else 
  {
    if (whiteList.indexOf(to.path) !== -1) 
    {
      // 在免登录白名单，直接进入
      next()
    } 
    else 
    {
      next('/login') // 否则全部重定向到登录页
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js